import { render, staticRenderFns } from "./OpportunityView.vue?vue&type=template&id=42694ba1&scoped=true"
import script from "./OpportunityView.vue?vue&type=script&lang=js"
export * from "./OpportunityView.vue?vue&type=script&lang=js"
import style0 from "./OpportunityView.vue?vue&type=style&index=0&id=42694ba1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42694ba1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42694ba1')) {
      api.createRecord('42694ba1', component.options)
    } else {
      api.reload('42694ba1', component.options)
    }
    module.hot.accept("./OpportunityView.vue?vue&type=template&id=42694ba1&scoped=true", function () {
      api.rerender('42694ba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Opportunity/OpportunityView.vue"
export default component.exports